import { z } from 'zod';

const enderecoSchema = z.object({
  cep: z.string().min(8, 'CEP obrigatório'),
  logradouro: z.string().min(1, 'Logradouro obrigatório'),
  numero: z.string().min(1, 'Número obrigatório'),
  complemento: z.string().optional(),
  bairro: z.string().min(1, 'Bairro obrigatório'),
  cidade: z.string().min(1, 'Cidade obrigatória'),
  uf: z.string().length(2, 'UF obrigatória'),
  latitude: z.number().optional(),
  longitude: z.number().optional(),
});

export const step1Schema = z.object({
  // Projeto
  tipo_solicitacao: z.enum(['VendaConcluida', 'HomologacaoPrevia']),
  ampliacao_usina: z.boolean(),
  potencia_existente_kw: z.number().positive().optional(),
  descricao_usina_existente: z.string().optional(),
  potencia_adquirida_kwp: z.number().positive('Potência obrigatória'),
  tipo_estrutura: z.enum(['Metalico', 'Ceramico', 'Solo', 'Carport', 'Fibrocimento', 'Fibromadeira', 'Laje']),
  modalidade_compensacao: z.string().min(1, 'Modalidade obrigatória'),
  tipo_compensacao: z.string().optional(),
  concessionaria_id: z.number().int().positive('Concessionária obrigatória'),
  tipo_localizacao: z.enum(['urbana', 'rural']),
  coordenadas_transformador: z.string().optional(),

  // Cliente (conditional on VendaConcluida)
  tipo_pessoa: z.enum(['PF', 'PJ']).optional(),
  nome_completo: z.string().optional(),
  email_cliente: z.string().optional(),
  telefone: z.string().optional(),
  cpf: z.string().optional(),
  estado_civil: z.string().optional(),
  profissao: z.string().optional(),
  razao_social: z.string().optional(),
  cnpj: z.string().optional(),
  finalidade_empresa: z.string().optional(),
  cargo_representante: z.string().optional(),

  // Endereços
  endereco_faturamento: enderecoSchema.optional(),
  endereco_instalacao: enderecoSchema.optional(),
  endereco_instalacao2: enderecoSchema.optional().nullable(),
  mesmo_endereco: z.boolean().optional(),
  url_local_instalacao: z.string().optional(),
  coordenada_geografica: z.string().optional(),
});

export type Step1Data = z.infer<typeof step1Schema>;
